module.exports = __webpack_public_path__ + "static/media/capsula.11b5f14a.png";